import { Component, OnInit } from '@angular/core';
import {UserService} from '../services/user.service';
import {CookieService} from 'ng2-cookies';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
 
@HostListener('window:keydown', ['$event'])
 @Component({
  host: {
     '(document:keydown)': 'keyDown($event)',
   },
   templateUrl: './header.component.html',
   styleUrls: ['./header.component.css'],
   selector: 'header'
  })

 export class HeaderComponent implements OnInit { 
    autos: Auto[];
   public selectedAuto;
   selectedIndex = 0;
   showAuto = false;
   public menu = false;
   public showSearch = false;
   theUser: string;
   searchText: string;
   gwt: string;
   public LOGO = require("../../assets/uiloq-logo.png");
   counter = 0;
   gotomenu = "";

   @HostListener('click')
   clickInside() {
     if (this.showSearch === true) {
       this.showAuto = true;
     }
   }

   @HostListener('document:click')
   clickout() {
     if (this.showAuto === false) {
       this.showSearch = false;
     }
       this.showAuto = false;
   }
   
   constructor(private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router, private _cookieService:CookieService){} 
 
   ngOnInit(){
      this.activatedRoute.queryParams.subscribe(params => {
        this.searchText = params['q'] || "";
      });

     this.gwt = this.getCookie("gwt");
     if(this.gwt) {
       this.userSVC.sessionVerifyGwt(this.gwt);
       setTimeout(()=>{this.theUser = this.userSVC.authUser.email;}, 1000)
     }

     //use typescript async
     //this.combo("abcd", 3)
   }

   setCookie(key: string, value: string){
       return this._cookieService.set(key, value);
     }
    getCookie(key: string){
       return this._cookieService.get(key);
     }

     logout(){
       if(!confirm("Do you want to Sign Out from Siloq®?")) {
         return;
       }
        this.setCookie("gwt", "");
        this.userSVC.logoutGwt(this.gwt);
        this.theUser = "";
        this.gwt = "";
        this.router.navigate(['login']);
      }

   help(){
     if (this.searchText) {
	     this.router.navigate(['/publish'],  { queryParams: { h : 'help'}});
     }
   }
 
   tagndoc(){
     this.router.navigate(['admin/tagndoc']);
   }

   toggleMenu(event:any){
   if(this.menu) {
     this.menu = !this.menu;
     this.showSearch = false;
     }
     event.stopPropagation();
   }
    auto() {
   //Use a queue for managing in-flight requests

         var res = this.searchText.trim().split(" ");
         var txt = res[res.length - 1];
         txt = txt.trim()
   var head  = this.searchText.substring(0,this.searchText.indexOf(txt)).trim();

   this.counter++;
   var thisCounter = this.counter;
      //var timeoutId = setTimeout(()=> {
   this.showAuto = false;
     /*
   if (txt.length > 2) {
       this.autos = new Array();
       //TODO: [0] current auto textbox value
       //  let t = new Auto();
       //   this.searchText;
       //   t.Rank = 0;
       //   this.autos = new Array()
       //   this.autos[0] = t;

         this.autoService.auto(txt)
              .subscribe(
                  data => {
                  //       this.autos = this.autos.concat(data); //Bind to view
                  if (this.counter == thisCounter) {
                 this.autos = data; //Bind to view

                 if (this.autos.length > 0) {
                   this.showAuto = true;
                   } else {
                     this.showAuto = false;
                   }

                 var i;
                 for (i = 0; i < this.autos.length; i++) {
                   this.autos[i].Name = head  + " " + this.autos[i].Name;
                 }
             }
             },
             err => {
               console.log(err);
             });
       } else {
      */
         this.autos = new Array();
     let t = new Auto();
     t.Name = "Help";
     t.Rank = 0;
     this.autos.push(t);
     //this.showAuto = false;
         this.showAuto = true;
     //}
         //     }, 1000/60);
     //  clearTimeout(timeoutId);
   }

   public selectAuto( auto: any, i: number) {
                 this.selectedIndex = i;
                 this.selectedAuto =  auto;
     this.searchText = this.selectedAuto.Name;
     this.showSearch = !this.showSearch; 
     this.help();
     this.showAuto = false;
     this.searchText = ""; 
   }

   keyDown(event: any) {
     switch (event.keyCode) {
       case 27:
               this.toggleMenu(event);
               event.preventDefault();
               break;
       case 38:
               this.onUp();
               event.preventDefault();
               break;
       case 40:
               this.onDown()
               event.preventDefault();
               break;
         /*
       case 13:
       this.help();
       event.preventDefault();
         break;
        */
     }
     return;
   }

   public onDown() {
                 if(this.selectedIndex < this.autos.length - 1)
                 {
                         this.selectedAuto = this.autos[++this.selectedIndex];
       this.searchText = this.selectedAuto.Name;
                 }
         }

         public onUp() {
                 if(this.selectedIndex > 0)
                 {
                         this.selectedAuto = this.autos[--this.selectedIndex];
       this.searchText = this.selectedAuto.Name;
                 }
         }

	public combo(s: string, l: number) {
		if (l==0) {
		setTimeout(()=>{
			this.gotomenu = s;
			return;
			}, 1000);
		}

		var i = l;
		for (var k=0; k<=l; k++) {
			s = this.swapFirstChar(s, i);

			l--;
			this.combo(s, l);
			l++;
		}
	}

	public swapFirstChar(s: string, l: number) {
		var c = s[0];

		var i = 1;
		for (; i <= l; i++) {
			s = s.substring(0, i-1) + s[i] + s.substring(i);
		}
		i--;
		s = s.substring(0, i) + c + s.substring(i+1);

		return s;
	}

 }

export class Auto  {
          public Name: string;
          public Rank: number;
  }
  



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts